<template>
    <div >

        <v-card

                flat
                max-width="204"
                style="background:transparent;"
                class="mx-auto"
                min-width="204"
        >


            <v-card-text @mouseleave="unlift" @mouseover="lift"  class="pb-0 pa-0">
                <v-card :class="animation" elevation="20" dark raised  :style="{ backgroundImage: `url('${background_image}')`}" style="background-size:cover;cursor:pointer;" height="284" width="204">
                    <img :src="streamer_image" @load="total_load+=1"   style="z-index: 1; position: absolute; width: 154px; top: 34px; left: 25px; height: 110px;"/>

                    <img :src="decorator_image" @load="total_load+=1" style="z-index:2;height:100%;width:100%;background-size:cover;position: absolute;"/>
                    <v-textarea
                            dark
                            style="position: absolute; bottom: 28px; width: 180px; left: 10px; height: 80px;overflow:hidden;"
                            class="ac_textarea"
                            solo
                            v-model="this.data.TEXT"
                            label=""
                            no-resize
                            readonly
                            height="80"
                    ></v-textarea>

                </v-card>

            </v-card-text>
            <v-card-actions style="position:relative;top:10px;" class="pa-0 mt-0">

                <v-btn
                        v-show="animation==='lift'"
                        :color=rank_color
                        tile

                        depressed


                        class="mx-auto"
                >
                    <b>{{data.NAME}}</b>
                </v-btn>




            </v-card-actions>
        </v-card>
    </div>

</template>

<script>
    export default {
        name: "ActionCardStatic",
        data(){
            return{
                total_load:0,
                animation:"",
                isAnimating:false




            }
        },
        props: {
            "data":Object
        },
        mounted:function(){
            this.lift();
            let self=this;
            setTimeout(function(){
                self.unlift();
            },100)
        },

        computed:{



            background_image:function(){

                return `/api/images/cards/activity/bg.png`
            },
            decorator_image:function(){
                return `/api/images/cards/activity/${this.data.RANK}.png`
            },
            streamer_image:function(){
                let random=(parseInt(Math.random()*1000)).toString();
                return  `/api/images/cards/streamer_images/${this.data["STID"]}/${this.data.RANK}.png?random=${random}`

            },
            streamer_avatar:function(){
                return  `/api/images/cards/streamer_images/${this.data["STID"]}/avatar.png`

            },
            rank_color:function(){
                if(this.data.RANK===0){
                    return "green"
                }
                else if(this.data.RANK===1){
                    return "blue"
                }
                else if(this.data.RANK===2){
                    return "purple"
                }
                else if(this.data.RANK===3){
                    return "orange"
                }
                else{
                    return "black"
                }
            },
            rank_text:function(){
                if(this.data.RANK===0){
                    return "Vanlig"
                }
                else if(this.data.RANK===1){
                    return "Ovanlig"
                }
                else if(this.data.RANK===2){
                    return "Epic"
                }
                else if(this.data.RANK===3){
                    return "Legendary"
                }
                else{
                    return "Okänd"
                }
            }
        },

        methods:{
            unlift:function(){
                if(!this.isAnimating){
                    this.animation="unlift";
                }
                else{
                    let self=this;
                    setTimeout(function(){
                        self.animation="unlift";
                    },300)
                }
            },
            lift:function(){
                this.animation="lift";
                this.isAnimating=true;
                let self=this;
                setTimeout(function(){
                    self.isAnimating=false;
                },300)
            }


        }
    }
</script>

<style scoped>
    .unlift {
        transform: translateY(0);
        transition: transform .2s;
    }
    .lift {
        transform: translateY(-80px) rotate(2deg);
        transition: transform .2s;
    }

</style>
